module.exports = __webpack_public_path__ + "static/img/jingyin.1eb2f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/jingyin.png
// module id = atml
// module chunks = 24